export default __webpack_public_path__ + "static/media/gray-star.0e3b9919.png";